import { useContext } from 'react'

//context
import { ActivityFeedContext } from '@/context/ActivityFeedContext';

//components
import { LoadingSpinner, PanelButton } from "thrive-components";
import ActivityList from './ActivityList';



const ActivityFeed = ({isPopOut}:{isPopOut: boolean}) => { 
    
    const {isLoading, activities, totalActivities, newActivitiesCount, updateFeed, getMoreActivities, noActivitiesMessage} = useContext(ActivityFeedContext);

    return(
        <div className={`activity-feed ${isPopOut ? "pop-out-activity-feed" : "full-screen-activity-feed"}`}>       
            {newActivitiesCount > totalActivities && <PanelButton content={'Load new activity'} ariaLabel={'Refresh your feed with latest activities'} onButtonClick={updateFeed} className='more-activities-button' />}


            {isLoading 
                ?   <LoadingSpinner size={20}/>

                :   (activities.length > 0)
                    ?   <ActivityList isPopOut={isPopOut} activities={activities} showNoMoreActivitiesMessage={activities.length === totalActivities} getMoreActivities={getMoreActivities}/>
                    :   <span className='activity-message'>{noActivitiesMessage}</span>
            }         
        </div>
    )
}
export default ActivityFeed